import _axios from '@/assets/utils/_axios'
import axios from 'axios'
import { _confirm, _alert, _loading } from '../../assets/utils/utils'
import Router from '@/router'
//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;

export default {
   /*获取订单详情信息*/
  async POST_OrderHotelDetail ({ commit, getters }, {data}) {
      let t = getters.storeInfo.type, url = '';
      switch (t) {
        case 2:
          url = '/pc/Travel/OrderHotelDetail';
          break
        case 3:
          url = '/pc/Hotel/OrderHotelDetail';
          break
        case 99:
          url = '/pc/Admin/OrderHotelDetail';
          break
      }
      let res = await _axios.post(url, {...data, store_id: getters.storeInfo.storeId});
      if (res.code === '00000') {
        let resInfo = res.data;
        return resInfo;
      }
  },
  /*修改时·获取酒店房型信息*/
  async POST_HotelsRoomList ({ commit, getters }, data) {
      let res = await _axios.post('/pc/User/GetHotelRoomTitleList', data);
      if (res.code === '00000') {
        commit('UPDATEROOMLIST',res.data.list);
      }
  },
  /*修改时·获取酒店会议室信息*/
  async POST_HotelsMeetingList ({ commit, getters }, data) {
      let res = await _axios.post('/pc/User/GetHotelMeetingTitleList', data);
      if (res.code === '00000') {
        commit('UPDATEMEETINGLIST',res.data.list);
      }
  },
  /*采购商发布订单*/
  async POST_SendOrderHotel ({commit, getters }, data) {
    let res = await _axios.post('/pc/Travel/SendOrderHotel', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') {
      return res.data
    }
  },
  /*采购商修改订单*/
  async POST_travelPostOrder ({commit, getters }, data) {
    let url=getters.userInfo.type==2?'/pc/Travel/StartEditOrderHotel':'/pc/Hotel/StartEditOrderHotel'
    let res = await _axios.post(url, {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
  /*发布确认订单*/
  async POST_SendOrderHotelConfirm ({commit, getters }, data) {
    let res = await _axios.post('/pc/User/SendOrderHotelConfirm', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
   /*同意修改订单*/
  async POST_EditOrderHotel ({ dispatch,commit, getters }, {data,successFun}) {
    console.log(data)
    let t = getters.storeInfo.type, url = '';
    switch (t) {
        case 2:
          url = '/pc/Travel/EndEditOrderHotel';
          break
        case 3:
          url = '/pc/Hotel/EndEditOrderHotel';
          break
    }
    let res = await _axios.post(url, {
        store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
        ...data
    });
    if (res.code === '00000') {
      successFun()
    }
  },
    /*采购商设置代收款*/
  async POST_SetOrderHotelBroker ({commit, getters }, data) {
    let res = await _axios.post('/pc/Travel/SetOrderHotelBroker', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
    //计算订单总金额
  async POST_ComputeOrderHotelPrice ({ commit, getters }, data) {
      const res = await _axios.post('/pc/Visitor/ComputeOrderHotelPrice',data);
      if(res.code=="00000"){
          return res.data.info
      }
  },
  //供应商添加导游列表获取
  async  POST_GuideList ({ commit, getters }, data){
      let src=data.tab==1?'/pc/Travel/GuideList':'/pc/Travel/LeaderList'
      const res = await _axios.post(src,data);
      if(res.code=="00000"){
        return res.data
      }
  },
  //旅行社添加核房人、支付人
  async  POST_OrderHotelSetVerify ({ commit, getters }, {data,tab}){
      let src=tab==1?'/pc/Travel/OrderHotelSetVerify':'/pc/Travel/OrderHotelSetPay'
      const res = await _axios.post(src,data);
      return res
  },
  //供应商添加导游列表获取
  async  POST_AddGuide ({ commit, getters }, {data,tab}){
      let src=tab==1?'/pc/Travel/AddGuide':'/pc/Travel/AddLeader'
      const res = await _axios.post(src,{...data,store_id:getters.storeInfo.storeId});
      return res
  },
  //旅行社-删除(核房人/支付人)
  async  POST_OrderHotelDelPay ({ commit, getters }, {data,tab}){
       let src=tab==1?'/pc/Travel/OrderHotelDelVerify':'/pc/Travel/OrderHotelDelPay'
      const res = await _axios.post(src,{...data,store_id:getters.storeInfo.storeId});
      return res
  },
  //旅行社-修改人员名单名称
  async  POST_OrderHotelRenameTrip ({ commit, getters }, {data}){
      const res = await _axios.post('/pc/Travel/OrderHotelRenameTrip',{...data,store_id:getters.storeInfo.storeId});
      if(res.code=="00000"){
        return res
      }
  },
}